@if (isVisible) {
  <div class="inline-status-indicator">
    <span [ngClass]="textClass" title="{{ text }}">
      @if (resolvedState === 'saving' && showSpinner()) {
        <fa-icon [icon]="icons.spinner" [animation]="'spin'" class="me-1"></fa-icon> 
      } @else if (resolvedState === 'error') {
        <fa-icon [icon]="icons.xMark" class="me-1 text-danger"></fa-icon>
      } @else if (resolvedState === 'success') {
        <fa-icon [icon]="icons.check" class="me-1 text-success"></fa-icon>
      }
      {{ text }}
    </span>
  </div>
}
